import { Routes } from '@angular/router';






export const routes: Routes = [
    // the shared front door (juno docs/ui/sign-in.md); what differs from juno is APP_INFO in
    // app.config. Still the root path, so AuthConfig.loginPath '/' and NAV_FREE_ROUTES stand.
    {path: '', loadComponent: () => import('@libs/ui/sign-in/sign-in.component').then(m => m.SignInComponent)},
    {path: 'customers', loadComponent: () => import('./components/dashboard/dashboard.component').then(m => m.DashboardComponent)},
    // Placeholder until phase 1 of the assignment-tests move lands here.
    {path: 'booking-tests', loadComponent: () => import('./components/booking-tests/booking-tests.component').then(m => m.BookingTestsComponent)},
    {path: 'turn-demo', loadComponent: () => import('./components/turn-demo/turn-demo.component').then(m => m.TurnDemoComponent)},
    {path: 'version', loadComponent: () => import('@libs/ui/version/version.component').then(m => m.VersionComponent)},
    // an employee's own login and password (docs/ui/my-account.md); dark until argus configures mePath
    {path: 'my-account', loadComponent: () => import('@libs/ui/my-account/my-account.component').then(m => m.MyAccountComponent)}
];
